import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MoveSandbox } from '@app/move/sandboxes/move.sandbox';
import { UiSandbox } from '@smooved/ui';

@Component({
    selector: 'app-complete-data-boiler-maintenance',
    template: `
        <div class="u-flex-column">
            <div class="u-flex-row">
                <div class="u-flex-no-shrink u-margin-right">
                    <img class="__image" src="assets/images/smooved-hand.png" />
                </div>
                <div>
                    <div class="u-flex-row u-flex-align-items-center u-margin-bottom-half">
                        <h4>{{ 'DASHBOARD.COMPLETE_DATA.BOILER_MAINTENANCE.TITLE' | translate }}</h4>
                        <app-check-with-background height="20" width="20" class="u-margin-left-half"></app-check-with-background>
                    </div>
                    <div *ngIf="uiSandbox.tabletPortraitUp$ | async">
                        <app-button type="button" theme="tertiary" [disabled]="true"
                            >{{ 'DASHBOARD.COMPLETE_DATA.BOILER_MAINTENANCE.COMPLETE' | translate }}
                        </app-button>
                    </div>
                </div>
                <div *ngIf="uiSandbox.upToAndIncludingPhoneLandscape$ | async">
                    <app-button type="button" theme="tertiary" class="u-w100p" [disabled]="true"
                        >{{ 'DASHBOARD.COMPLETE_DATA.BOILER_MAINTENANCE.COMPLETE' | translate }}
                    </app-button>
                </div>
            </div>
        </div>
    `,
    styleUrls: ['./complete-data-boiler-maintenance.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompleteDataBoilerMaintenanceComponent {
    constructor(
        public moveSandbox: MoveSandbox,
        public uiSandbox: UiSandbox
    ) {}
}
